module.exports = __webpack_public_path__ + "static/media/template-outfits.ea5ca315.csv";